import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-security-data',
  templateUrl: './security-data.component.html',
  styleUrls: ['./security-data.component.css']
})
export class SecurityDataComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/corporate/security-data/security-data.component.ts